import React, { ReactNode, useState, useEffect, useLayoutEffect } from "react";
import Box from "@material-ui/core/Box";
import Hidden from "@material-ui/core/Hidden";

import { colorAuthBackground } from "../../../Constants/theme";

import { ReactComponent as AuthBackground } from "../../../Images/authBackground.svg";
import {CircularProgress, useMediaQuery} from "@material-ui/core";
import {useTheme} from "@material-ui/core/styles";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../../redux/store";
import {useLocation} from "react-router";
import WebFont from "webfontloader";
import {getBranding} from "../../../redux/branding/branding.actions";
import {useSnackbar} from "notistack";

type Props = {
	children: ReactNode
}
const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};


const Auth: React.FC<Props> = ({children}: Props) => {
    const theme = useTheme();
    const query = useQuery();
    const dispatch = useAppDispatch();
    const partnerId = query.get("partnerId");
    const [brandingLoad, setBrandingLoad] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
    const branding = useSelector((state: RootState) => state?.branding);
    const { enqueueSnackbar } = useSnackbar();
    useLayoutEffect(() => {
        (async () => {
            if (branding.partnerPreferencesOn) {
                const link = document.querySelector("link[rel='icon']");
                // @ts-ignore
                link.href = link.getAttribute("data-ico-label");
            }
            if (partnerId) {
                const link = document.querySelector("link[rel='icon']");
                // @ts-ignore
                link.href = link.getAttribute("data-ico-label");
                await dispatch(getBranding(partnerId)).then((res) => {
                    WebFont.load({
                        google: {
                            families: [res.font?.header, res.font?.text]
                        }
                    });
                    setBrandingLoad(true);
                }
                )
                    .catch(err => {
                        enqueueSnackbar("Can not find partner by given id", {
                            variant: "error",
                            autoHideDuration: 3000
                        });
                        setBrandingLoad(true);
                    }
                    );
            }
        })();
    }, []);
    return (
        <>
            { !partnerId || brandingLoad ?
                <Box
                    height="100%"
                    bgcolor={colorAuthBackground}
                    paddingTop="7vh"
                >
                    <Hidden xsDown>
                        <Box
                            position="fixed"
                            marginLeft="auto"
                            marginRight="auto"
                            left="0"
                            right="0"
                            textAlign="center"
                            width="100%"
                            zIndex="0"
                        >
                            {/* 90% so it's not going through borders of window */}
                            {
                                !branding.partnerPreferencesOn &&
                                <AuthBackground width="90%"/>
                            }
                        </Box>
                    </Hidden>
                    <Box
                        marginTop={isMobile? "4vh" : "8vh"}
                    >
                        {children}
                    </Box>
                </Box> :
                <></>
            }
        </>
    );
};

export default Auth;
